export function Shorter() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8333 0H1.16672C0.525171 0 0 0.525342 0 1.16689V12.8334C0 13.475 0.525171 14 1.16672 14H12.8333C13.4748 14 14 13.475 14 12.8334V1.16689C14 0.525342 13.4748 0 12.8333 0ZM6.58769 6.00441C6.58769 6.32642 6.32553 6.58786 6.00424 6.58786H2.50424V5.42148L4.59601 5.4208L1.75 2.57513L2.57496 1.75L5.421 4.59621L5.42049 2.50445H6.58772V6.00441H6.58769ZM11.425 12.2507L8.579 9.40447V11.4962H7.41228V7.99624C7.41228 7.67457 7.67372 7.41313 7.99572 7.41313L11.4957 7.41241V8.57897L9.40396 8.57968L12.25 11.4259L11.425 12.2507Z"
        fill="url(#paint0_linear_0_88)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_0_88"
          x1="7"
          y1="0"
          x2="7"
          y2="14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EC6181" />
          <stop offset="1" stopColor="#5C69E3" />
        </linearGradient>
      </defs>
    </svg>
  );
}
